import React from "react"
import { Amplify } from "aws-amplify"
import { Authenticator } from "@aws-amplify/ui-react"

import { getConfig } from "@components/Config"
import { PublicOrganizationContext, usePublicOrganization } from "@components/AppContext"

import getFormFields from "./helpers/getFormFields"
import getQueryParams from "./helpers/getQueryParams"

import Header from './Header'
import Footer from './Footer'
import ConfirmSignUpHeader from "./ConfirmSignUpHeader"
import ConfirmSignUpFooter from "./ConfirmSignUpFooter"
import ConfirmSignInHeader from "./ConfirmSignInHeader"
import ConfirmSignInFooter from "./ConfirmSignInFooter"
import ResetPasswordHeader from './ResetPasswordHeader'
import ResetPasswordConfirmHeader from './ResetPasswordConfirmHeader'
import ResetPasswordConfirmFooter from "./ResetPasswordConfirmFooter"

import "@aws-amplify/ui-react/styles.css"
import "./AuthenticatorContext.css"

const AUTHENTICATOR_CONFIG = getConfig("AUTHENTICATOR_CONFIG")
Amplify.configure(AUTHENTICATOR_CONFIG)


const AuthenticatorContext = ({ children }) => {
  const publicOrganization = usePublicOrganization()

  const { name, logoUrl } = publicOrganization

  const isPublicScope =
    window.location.pathname.startsWith("/scf/create") ||
    window.location.pathname.startsWith("/scf/reminders") ||
    window.location.pathname.startsWith("/scf/thank-you")

  const { email, action: initialState } = getQueryParams()

  const components = {
    Header: () => Header(name, logoUrl),
    Footer: () => Footer(name),
    ResetPassword: {
      Header: ResetPasswordHeader,
    },
    ConfirmSignIn: {
      Header: ConfirmSignInHeader,
      Footer: ConfirmSignInFooter,
    },
    ConfirmSignUp: {
      Header: ConfirmSignUpHeader,
      Footer: ConfirmSignUpFooter,
    },
    ConfirmResetPassword: {
      Header: ResetPasswordConfirmHeader,
      Footer: ResetPasswordConfirmFooter,
    },
  }

  const formFields = getFormFields(email)
  const loginMechanisms = [ "email" ]

  if (isPublicScope) {
    return (
      <PublicOrganizationContext.Provider value={{ publicOrganization }}>
        {children}
      </PublicOrganizationContext.Provider>
    )
  }

  return (
    <Authenticator
      components={components}
      formFields={formFields}
      initialState={initialState}
      loginMechanisms={loginMechanisms}
      /* td: Enable after backend is ready */
      // socialProviders={["google"]}
    >
      {
        () => (
          <PublicOrganizationContext.Provider value={{ publicOrganization }}>
            {children}
          </PublicOrganizationContext.Provider>
        )
      }
    </Authenticator>
  )
}

export default AuthenticatorContext
